import { render, staticRenderFns } from "./html/pd-readiness-quiz.html?vue&type=template&id=20c0ac1c&scoped=true&"
import script from "./pd-readiness-quiz-edu.vue?vue&type=script&lang=js&"
export * from "./pd-readiness-quiz-edu.vue?vue&type=script&lang=js&"
import style0 from "./pd-readiness-quiz-edu.vue?vue&type=style&index=0&id=20c0ac1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0ac1c",
  null
  
)

export default component.exports